import { useHomepage } from '../application'

const Homepage = () => {
  useHomepage()
  return <div>Loading...</div>
}

export { Homepage }
